// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import addDays from "@insite/client-framework/Common/Utilities/addDays";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getOrderState, OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import loadShipTos from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTos";
import { getShipTosDataView } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block/Block";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@store/Overrides/Components/AddressInfoDisplay";
import { orderProps } from "@store/Themes/common/props/order";
import constants from "@store/constants";
import setNewContextualisedShipTo from "@store/Framework/Store/Greif/Pages/RequestOrderChange/Handler/SetNewContextualisedShipTo";
import updateChangeRequestOrder from "@store/Framework/Store/Greif/Pages/RequestOrderChange/Handler/UpdateChangeRequestOrder";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@store/MobiusOverrides/DatePicker/DatePicker";
import ChangeCustomerShipToSelector, {
    ChangeCustomerShipToSelectorStyles,
} from "@store/Overrides/Widgets/ChangeCustomer/ChangeCustomerShipToSelector";
import { infoProps } from "@store/Themes/common/props/info";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";

const OrderDate = getWidgetComponent("OrderDetails/OrderDate");
const Notes = getWidgetComponent("OrderDetails/OrderDetailsNotes");
const Status = getWidgetComponent("OrderDetails/OrderDetailsStatus");
const Salesperson = getWidgetComponent("OrderDetails/OrderSalesperson");
const RequestedDate = getWidgetComponent("OrderDetails/OrderDetailsRequestedDate");
const Carrier = getWidgetComponent("OrderDetails/OrderDetailsCarrier");
const DeliveryTerms = getWidgetComponent("OrderDetails/OrderDetailsDeliveryTerms");
const PaymentTerms = getWidgetComponent("OrderDetails/OrderDetailsPaymentTerms");
const PoNumber = getWidgetComponent("OrderDetails/OrderPo");
const ShippingAddress = getWidgetComponent("OrderDetails/OrderDetailsShippingAddress");
const BillingAddress = getWidgetComponent("OrderDetails/OrderDetailsBillingAddress");
const VatNumber = getWidgetComponent("OrderDetails/OrderDetailsVatNumber");
const VmiLocation = getWidgetComponent("OrderDetails/OrderDetailsVmiLocation");

const enum fields {
    informationTitle = "informationTitle",
    informationSubtitle = "informationSubtitle",
}

interface OwnProps extends WidgetProps {
    orderState?: ReturnType<typeof getOrderState>;
    fields: {
        [fields.informationTitle]: string;
        [fields.informationSubtitle]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const settingsCollection = getSettingsCollection(state);
    const {
        accountSettings: { enableWarehousePickup },
    } = getSettingsCollection(state);
    const { fulfillmentMethod } = getSession(state);
    return {
        cartSettings: settingsCollection.cartSettings,
        billToId: state.context.session.billToId,
        enableWarehousePickup,
        fulfillmentMethod,
        changeRequestOrderState: state.greif.pages.orderChange,
        language: state.context.session.language,
    };
};

const mapDispatchToProps = {
    loadShipTos,
    setNewContextualisedShipTo,
    updateChangeRequestOrder,
};

export interface OrderDetailsInformationStyles {
    block?: BlockProps;
    orderNumberHeading?: TypographyProps;
    infoGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    infoLabel?: TypographyPresentationProps;
    infoValue?: TypographyPresentationProps;
    notesGridItem?: GridItemProps;
    shippingInformationTitle?: TypographyProps;
    billingInformationTitle?: TypographyProps;
    billingShippingGridItem?: GridItemProps;
    billingShippingWrapper?: InjectableCss;
    orderChangeDatePicker?: DatePickerPresentationProps;
    newPoNumberField?: TextFieldPresentationProps;
    shipToSelector?: ChangeCustomerShipToSelectorStyles;
    shipToAddressTitleText?: TypographyProps;
    shipToAddressDisplay?: AddressInfoDisplayStyles;
    infoOldValueItem?: GridItemProps;
    infoNewValueItem?: GridItemProps;
    removeLink?: LinkPresentationProps;
}

export const orderDetailsInformationStyles: OrderDetailsInformationStyles = {
    block: { ...orderProps.block, variantSide: "bottom" },
    orderNumberHeading: orderProps.subtitle,
    infoGridContainer: infoProps.grid?.container,
    infoGridItem: {
        width: [6, 3, 4, 3, 3],
        printWidth: 4,
        css: css`
            display: block;
        `,
    },
    notesGridItem: infoProps.grid?.fullItem,
    shippingInformationTitle: orderProps.subtitle,
    billingInformationTitle: orderProps.subtitle,
    billingShippingGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    billingShippingWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: ${pxToRem(16)};
        `,
    },
    orderChangeDatePicker: {
        cssOverrides: {
            formInputWrapper: css`
                width: 70%;
            `,
        },
    },
    newPoNumberField: {
        cssOverrides: {
            formInputWrapper: css`
                ${x => x.theme.textField.defaultProps?.css}
                width: 70%;
            `,
        },
    },
    shipToSelector: {
        shipToSelectorDynamicDropdown: {
            cssOverrides: {
                dropdownWrapper: css`
                    text-align: left;
                    width: 70%;
                `,
            },
        },
    },
    shipToAddressTitleText: infoProps.label,
    infoOldValueItem: {
        width: [12, 12, 6, 4, 4],
    },
    infoNewValueItem: {
        width: [12, 12, 6, 6, 6],
    },
    removeLink: {
        typographyProps: {
            css: css`
                margin-left: ${pxToRem(10)};
            `,
        },
    },
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const styles = orderDetailsInformationStyles;

const RequestOrderChangeInformation: FC<Props> = ({
    orderState: baseOrderState,
    cartSettings,
    billToId,
    enableWarehousePickup,
    fulfillmentMethod,
    loadShipTos,
    setNewContextualisedShipTo,
    updateChangeRequestOrder,
    changeRequestOrderState,
    language,
    fields: { informationTitle, informationSubtitle },
}) => {
    const { orderSettings, productSettings } = useSettingsCollection();
    const orderStateContext = useContext(OrderStateContext);
    const orderState = baseOrderState || orderStateContext;
    const order = orderState.value;
    const { changeRequestOrder, newShipTo } = changeRequestOrderState;

    const [orderDateChange, setOrderDateChange] = useState<Date | undefined>();
    const [newPoNumber, setNewPoNumber] = useState<string | undefined>();
    const [deliveryDateError] = useState(false);
    const [shipTosParameter, setShipTosParameter] = useState<GetShipTosApiParameter>({
        page: 1,
        pageSize: 20,
        expand: ["validation", "excludeShowAll", "excludeOneTime"],
        billToId,
    });

    const shipTosDataView = useSelector((state: ApplicationState) => getShipTosDataView(state, shipTosParameter));

    const [shipToSearchText, setShipToSearchText] = useState<string | undefined>("");
    const [shipTo, setShipTo] = useState<ShipToModel | undefined>();

    if (!order) {
        return null;
    }

    const showPoNumber = orderSettings.showPoNumber && order.customerPO;
    const showVatNumber = productSettings.enableVat && order.customerVatNumber;
    const showTerms = orderSettings.showTermsCode && order.terms;
    const showInformations =
        order.orderDate ||
        showPoNumber ||
        order.statusDisplay ||
        order.salesperson ||
        showVatNumber ||
        showTerms ||
        order.vmiLocationName ||
        order.notes ||
        order.requestedDeliveryDateDisplay ||
        order.properties.carrier ||
        order.properties.deliveryTerms;

    useEffect(() => {
        if (changeRequestOrder.newRequestedDate) {
            setOrderDateChange(new Date(changeRequestOrder.newRequestedDate));
        }

        if (changeRequestOrder.newPoNumber) {
            setNewPoNumber(changeRequestOrder.newPoNumber);
        }

        if (newShipTo) {
            setShipTo(newShipTo);
        }
    }, [changeRequestOrder.newRequestedDate, changeRequestOrder.newPoNumber, newShipTo]);

    const handleRequestPickUpDateChanged = ({ selectedDay, selectedDayDisabled }: DatePickerState) => {
        setOrderDateChange(selectedDay);
        updateChangeRequestOrder({
            changeRequestOrder: {
                ...changeRequestOrder,
                newRequestedDate: selectedDay,
            },
        });
    };

    useEffect(() => {
        if (!shipTosDataView.value && !shipTosDataView.isLoading) {
            loadShipTos({
                page: 1,
                pageSize: 20,
                expand: ["validation", "excludeShowAll", "excludeOneTime"],
                billToId,
            });
        }
    });

    const poNumberChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setNewPoNumber(event.target.value);
        updateChangeRequestOrder({
            changeRequestOrder: {
                ...changeRequestOrder,
                newPoNumber: event.target.value,
            },
        });
    };

    const shipToSelectedHandler = (shipTo: ShipToModel) => {
        setShipTo(shipTo);
        setNewContextualisedShipTo({ newShipTo: shipTo });
        updateChangeRequestOrder({
            changeRequestOrder: {
                ...changeRequestOrder,
                newShipToCompanyName: shipTo.companyName,
                newShipToAddress1: shipTo.address1,
                newShipToCity: shipTo.city,
                newShipToState: shipTo.state?.name,
                newShipToPostalCode: shipTo.postalCode,
                newShipToCountry: shipTo.country?.name,
                newShipToCode: shipTo.customerSequence,
            },
        });
    };

    const removeShipToHandler = () => {
        setShipTo(undefined);
        setNewContextualisedShipTo({ newShipTo: undefined });
        updateChangeRequestOrder({
            changeRequestOrder: {
                ...changeRequestOrder,
                newShipToCompanyName: undefined,
                newShipToAddress1: undefined,
                newShipToCity: undefined,
                newShipToState: undefined,
                newShipToPostalCode: undefined,
                newShipToCountry: undefined,
            },
        });
    };

    return (
        <OrderStateContext.Provider value={orderState}>
            <Block {...styles.block}>
                <Typography {...styles.orderNumberHeading}>
                    {translate("Greif Order Number: ")}
                    {order.erpOrderNumber ? order.erpOrderNumber : order.webOrderNumber}
                </Typography>
                {showInformations ? (
                    <GridContainer {...styles.infoGridContainer}>
                        {order.orderDate ? (
                            <GridItem {...styles.infoGridItem}>
                                <OrderDate />
                            </GridItem>
                        ) : null}
                        {order.statusDisplay ? (
                            <GridItem {...styles.infoGridItem}>
                                <Status />
                            </GridItem>
                        ) : null}
                        {order.salesperson ? (
                            <GridItem {...styles.infoGridItem}>
                                <Salesperson />
                            </GridItem>
                        ) : null}
                        {showVatNumber ? (
                            <GridItem {...styles.infoGridItem}>
                                <VatNumber />
                            </GridItem>
                        ) : null}

                        {order.vmiLocationName ? (
                            <GridItem {...styles.infoGridItem}>
                                <VmiLocation />
                            </GridItem>
                        ) : null}
                        {order.properties.carrier ? (
                            <GridItem {...styles.infoGridItem}>
                                <Carrier />
                            </GridItem>
                        ) : null}
                        {order.properties.deliveryTerms ? (
                            <GridItem {...styles.infoGridItem}>
                                <DeliveryTerms />
                            </GridItem>
                        ) : null}
                        {showTerms ? (
                            <GridItem {...styles.infoGridItem}>
                                <PaymentTerms />
                            </GridItem>
                        ) : null}

                        {order.notes ? (
                            <GridItem {...styles.notesGridItem}>
                                <Notes />
                            </GridItem>
                        ) : null}
                    </GridContainer>
                ) : null}
            </Block>
            <Block {...styles.block}>
                <GridContainer>
                    <GridItem {...styles.billingShippingGridItem}>
                        <BillingAddress />
                    </GridItem>
                </GridContainer>
            </Block>
            <Block {...styles.block}>
                <GridContainer>
                    <GridItem width={12}>
                        <StyledWrapper>
                            <Typography variant="h4" as="h4">
                                {
                                    // eslint-disable-next-line spire/avoid-dynamic-translate
                                    translate(informationTitle)
                                }
                            </Typography>
                            {informationSubtitle && (
                                <Typography variant="p">
                                    {
                                        // eslint-disable-next-line spire/avoid-dynamic-translate
                                        translate(informationSubtitle)
                                    }
                                </Typography>
                            )}
                        </StyledWrapper>
                    </GridItem>
                    <GridItem width={12}>
                        <GridContainer style={{ width: "100%" }}>
                            <GridItem {...styles.infoOldValueItem}>
                                {order.requestedDeliveryDateDisplay ? <RequestedDate /> : null}
                            </GridItem>
                            <GridItem {...styles.infoNewValueItem}>
                                <DatePicker
                                    label={translate("New Requested Date")}
                                    {...styles.orderChangeDatePicker}
                                    onDayChange={handleRequestPickUpDateChanged}
                                    selectedDay={orderDateChange}
                                    dateTimePickerProps={{
                                        minDate: new Date(),
                                        maxDate: addDays(new Date(), cartSettings.maximumDeliveryPeriod),
                                    }}
                                    error={deliveryDateError && translate("Please enter a valid date")}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem width={12}>
                        <GridContainer>
                            <GridItem {...styles.infoOldValueItem}>{showPoNumber ? <PoNumber /> : null}</GridItem>
                            <GridItem {...styles.infoNewValueItem}>
                                <TextField
                                    {...styles.newPoNumberField}
                                    type="text"
                                    onChange={poNumberChangeHandler}
                                    label={translate("New PO Number")}
                                    value={newPoNumber}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem width={12}>
                        <GridContainer>
                            <GridItem {...styles.infoOldValueItem}>
                                <ShippingAddress />
                            </GridItem>
                            <GridItem {...styles.infoNewValueItem}>
                                <StyledWrapper {...styles.billingShippingWrapper}>
                                    <ChangeCustomerShipToSelector
                                        extendedStyles={styles.shipToSelector}
                                        parameter={shipTosParameter}
                                        setParameter={setShipTosParameter}
                                        searchText={shipToSearchText}
                                        setSearchText={setShipToSearchText}
                                        enableWarehousePickup={enableWarehousePickup}
                                        fulfillmentMethod={fulfillmentMethod}
                                        onSelect={shipToSelectedHandler}
                                        billToId={billToId}
                                        shipTo={shipTo}
                                        overridedLabel={translate("Select New Ship To")}
                                    />
                                    {shipTo && shipTo.id && (
                                        <>
                                            <Typography {...styles.shipToAddressTitleText}>
                                                {translate("New Ship To Address")}
                                                <Link
                                                    {...styles.removeLink}
                                                    onClick={removeShipToHandler}
                                                >{`${translate("Remove")}`}</Link>
                                            </Typography>
                                            <AddressInfoDisplay
                                                companyName={shipTo.companyName}
                                                address1={shipTo.address1}
                                                address2={shipTo.address2}
                                                address3={shipTo.address3}
                                                // Greif Removed (address 4)
                                                city={shipTo.city}
                                                state={shipTo.state?.name}
                                                postalCode={shipTo.postalCode}
                                                country={shipTo.country?.name}
                                                extendedStyles={styles.shipToAddressDisplay}
                                            />
                                        </>
                                    )}
                                </StyledWrapper>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </Block>
        </OrderStateContext.Provider>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RequestOrderChangeInformation),
    definition: {
        group: constants.widgetGroup.orderChangeRequest,
        displayName: "Change Request Information",
        allowedContexts: ["OrderChangeRequestPage" as any],
        fieldDefinitions: [
            {
                name: fields.informationTitle,
                editorTemplate: "TextField",
                defaultValue: "Edit order information",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.informationSubtitle,
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
